import React from "react";
import RequestFranchiseForm from "../../views/RequestFranchiseForm/RequestFranchiseForm";
import LanguageProvider from "../../components/LanguageProvider/LanguageProvider";
import { locales } from "./locales";

function RequestFranchiseFormPage() {
  return (
    <LanguageProvider locales={locales}>
      <RequestFranchiseForm />
    </LanguageProvider>
  );
}

export default RequestFranchiseFormPage;
